import { djs } from "@/lib/djs";
import { cn } from "@/lib/utils";
import type { LoadedIntelligence } from "@/types/cockpit";

const factLabels = {
	interest: "Interesse",
	promise: "Promessa",
	objection: "Objeção",
	milestone: "Marco",
	referral: "Indicação",
};

export function ConversationContextFacts({ facts }: { facts: LoadedIntelligence["facts"] }) {
	return (
		<section className="mt-6" aria-label="Pontos importantes">
			<h3 className="text-xs font-semibold text-muted-foreground">Pontos importantes</h3>
			<ol className="mt-5 ml-1.5 border-l border-border">
				{facts.map((fact, index) => (
					<li key={`${fact.kind}:${index}`} className="relative pb-6 pl-5 last:pb-0">
						<span
							aria-hidden="true"
							className={cn(
								"absolute top-1 -left-1.5 size-3 rounded-full border border-primary bg-primary-soft ring-4 ring-card",
								index === 0 && "border-info bg-info",
							)}
						/>
						{!!fact.date && (
							<time dateTime={fact.date} className="mb-1.5 block text-xs text-muted-foreground">
								{djs(fact.date).locale("pt-br").format("DD MMM YYYY")}
							</time>
						)}
						<h4 className="font-display text-lg leading-snug text-foreground">
							{factLabels[fact.kind]}
						</h4>
						<p className="mt-1.5 break-words text-sm leading-6 text-muted-foreground">
							{fact.text}
						</p>
					</li>
				))}
			</ol>
		</section>
	);
}
